import './App.css';
import { Routes, Route } from 'react-router-dom';

import JSCNavbar from './components/NavBar/Navbar';
import JSCFooter from './components/Footer/Footer';
import Home from './components/Home/Home';
import Recommendations from './components/Recommendations/Recommendations';
import Services from './components/Services/Services'
import Contact from './components/Contact/Contact';
import NotFound from './components/NotFound/NotFound.js';
import Testimonials from './components/Testimonials/Testimonials.js';

import siteConfig from './resources/data/config.js';
import favicon from './resources/assets/favicon.ico';

function App() {
  return (
    <div className="App">
      <div className='header'>
        <JSCNavbar />
      </div>
      <div className='body'>
        <title>{siteConfig.name}</title>
        <link rel="icon" href={favicon} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="recommendations" element={<Recommendations />} />
          <Route path="services" element={<Services />} />
          <Route path="contact" element={<Contact />} />
          <Route path="testimonials" element={<Testimonials />} />
          {/* any link that is not real*/}
          <Route path='*' element={<NotFound />} />
        </Routes>
      </div>
      <div className='footer'>
        <JSCFooter />
      </div>
    </div>
  );
}

export default App;
